import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import { Row, Col, Button } from "react-bootstrap";
import { teaching_Staff, co_activity, admin_staff } from "../../variable";
import fsTopIcon from "../../asset/newImg/fs.png";
import "./Content.css";
import ContentMain from "./ContentMain";
function Faculty(props) {
  const {
    cover,
    sidebar_data,
    data,
    title,
    alumni_data,
    curriculum_data,
    side_heading,
    side_sub_heading,
  } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    console.log("asd");
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`} style={{ color: "#0076BD" }}>
            <img
              src={fsTopIcon}
              style={{ width: "4rem", marginRight: "1rem" }}
            />
            Faculty & Staff
          </div>
          <div>
            <div className="d-flex gap-2 mt-1">
              <div>
                {/* <div className="f-bold f-1-2 mb-2"></div> */}
                <div className="color-grey f-500">
                  HGS Palla has a very experienced,
                  knowledgeable, well-qualified and dedicated Staff, so much so
                  that they are conscious of their responsibility of being the
                  most important block in the foundation of the Nation as well
                  as the Society.
                </div>
                <div className="color-grey f-500 mt-2">
                  Their self-discipline is an example in itself, which always
                  drives them to work as a well-knit team to make all possible
                  endeavour together for the holistic growth of students as well
                  the institution. They are enthusiastic, dedicated,
                  conscientious and highly motivated to adapt to new innovative
                  ideas and well versed with modern education systems.
                </div>
                <div className="color-grey f-500 mt-2">
                  The valuable contribution of all the Faculty members is well
                  manifested in the spectacular achievements of our students in
                  the scholastic as well as co- scholastic discipline.
                </div>
                <div className="color-grey f-500 mt-2">
                  The Teachers grouped under various subject-wise Faculties are
                  put under the guidance of the most experienced Faculty heads.
                  All of them always put their heads together to devise
                  improvised methodology to deliver their best to facilitate the
                  young evolving minds. This significantly contributes in
                  promoting the problem solving skills of students to enable
                  them to grow as useful citizens.
                </div>
              </div>
            </div>
          </div>
          <div className="faculty_staff">
            <div className="d-flex gap-2 mt-3">
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className="mandatory_heading"
                  style={{
                    fontSize: "25px",
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    marginRight: "24%",
                    fontWeight: "700",
                  }}
                >
                  Teaching Staff
                </div>
                <div className="mandatory_table">
                  {teaching_Staff.map((item, index) => (
                    <Row
                      className="mandatory_list"
                      style={{ width: "80%" }}
                      key={index}
                    >
                      <Col className="mandatory_col" lg={1}>
                        {item.title}
                      </Col>
                      <Col className="mandatory_col" lg={3}>
                        {item.name}
                      </Col>
                      <Col className="mandatory_col" lg={4}>
                        {item.designation}
                      </Col>
                      <Col className="mandatory_col_last" lg={4}>
                        {item.qualification}
                      </Col>
                    </Row>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="faculty_staff">
            <div className="d-flex gap-2 mt-3">
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className="mandatory_heading"
                  style={{
                    fontSize: "25px",
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    marginRight: "24%",
                    fontWeight: "700",
                  }}
                >
                  Non-Teaching Staff
                </div>
                <div className="mandatory_table">
                  {admin_staff.map((item, index) => (
                    <Row
                      className="mandatory_list"
                      style={{ width: "80%" }}
                      key={index}
                    >
                      <Col className="mandatory_col" lg={1}>
                        {item.title}
                      </Col>
                      <Col className="mandatory_col" lg={3}>
                        {item.name}
                      </Col>
                      <Col className="mandatory_col_last" lg={6}>
                        {item.designation}
                      </Col>
                      {/* <Col className="mandatory_col_last" lg={4}>
                        {item.qualification}
                      </Col> */}
                    </Row>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Faculty;
